import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToFinalCTA = () => {
    const finalCTA = document.getElementById('final-cta');
    if (finalCTA) {
      finalCTA.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="relative w-full bg-[#fef3e2] overflow-hidden pt-12 pb-20 px-4 md:pt-20 md:pb-28" data-id="element-112">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-113">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="order-2 md:order-1" data-id="element-114">
          <div className="space-y-6" data-id="element-115">
            <p className="font-serif text-xl md:text-2xl text-slate-600 italic" data-id="element-116">
              Son las <span className="font-bold text-[#0d9488]" data-id="element-117">3:07am</span>.
            </p>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight" data-id="element-118">
              Te despiertas con el cuerpo cansado... <br data-id="element-119" />
              <span className="text-[#0d9488]" data-id="element-120">pero la mente no.</span>
            </h1>

            <p className="text-lg md:text-xl text-slate-700 leading-relaxed max-w-lg" data-id="element-121">
              Y en menos de 30 segundos ya estás haciendo inventario:
              pendientes, cuentas, familia, salud. Pero lo peor es esa frase
              silenciosa:
              <span className="block mt-2 font-semibold italic text-slate-800" data-id="element-122">
                "Si hoy tampoco duermo... mañana no voy a poder."
              </span>
            </p>

            <div className="pt-4" data-id="element-123">
              <button onClick={scrollToFinalCTA} className="group bg-[#0d9488] hover:bg-[#0f766e] text-white text-lg font-semibold py-4 px-8 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center gap-2" data-id="element-124">
                Quiero mi Plan Anti-3am
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-125" />
              </button>
              <p className="mt-3 text-sm text-slate-500" data-id="element-126">
                Guía digital (PDF) • Acceso inmediato
              </p>
            </div>
          </div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="order-1 md:order-2 flex justify-center" data-id="element-127">
          <div className="relative w-full max-w-md" data-id="element-128">
            <div className="absolute inset-0 bg-[#0d9488]/10 rounded-3xl transform rotate-3 scale-105 blur-xl" data-id="element-129"></div>
            <img src="https://cdn.magicpatterns.com/uploads/nfuwZ3fVECeBkxc1RiRYCs/portada_ebook_01.png" alt="Hormonas en Calma eBook en una tablet sobre la cama" className="relative z-10 w-full rounded-2xl shadow-2xl transform transition-transform duration-700 hover:scale-[1.01]" data-id="element-130" />
          </div>
        </motion.div>
      </div>
    </section>;
}